/**
 * Single style source for BOTH paper-usage charts (requirement: đồng bộ
 * style UI từ màu sắc đến highlight). Bar width, grid insets and glow live
 * here; the COLOR VALUES live in the central registry
 * (`@/shared/constants/chartColors`) and are re-exported under their stable
 * names, so the charts can never drift apart visually — nor from the other
 * pages. The dark tooltip chrome is the LIBRARY default now
 * (`tooltipChromeDefaults`), so both charts inherit it without per-widget
 * config.
 *
 * Hover has NO highlight (series `emphasis.disabled: true`) — the selection
 * is the only distinct color, baked into the series data as a per-item
 * `itemStyle` on the SELECTED column (no state actions involved). No focus
 * dimming — other items keep their colors.
 */

import {
  PAPER_USAGE_CHART_COLORS,
  PAPER_USAGE_PROGRESS_COLORS,
  type PaperUsageProgressColumnId,
} from "@/shared/constants/chartColors";

/** Chart palette (bar shades, share segments, Job Count line) — central registry. */
export const CHART_COLORS = PAPER_USAGE_CHART_COLORS;

/**
 * Soft shadow glow spread under the emphasized item on top of the accent
 * shade, so the selected column pops against its neighbours.
 */
export const CHART_HIGHLIGHT_GLOW = {
  shadowBlur: 14,
  shadowColor: "rgba(30, 64, 175, 0.55)",
  shadowOffsetY: 3,
} as const;

export const CHART_BAR_WIDTH = "55%";

/** Shared grid insets (chart 1 adds extra bottom room for its dataZoom). */
export const CHART_GRID = { top: 56, left: 72, right: 72 } as const;

/** Fill color per table measure column — central registry (derived from the
 *  canonical ink palette). Consumed by the library's `progressColumn`
 *  display via the column config. */
export const PROGRESS_COLORS = PAPER_USAGE_PROGRESS_COLORS;

export type ProgressColumnId = PaperUsageProgressColumnId;
